module.exports = __webpack_public_path__ + "img/9ade770.png";